import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import type { BreadcrumbItem } from '../types/wiki'

export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  if (items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="no-print mb-4 text-sm text-gray-400">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => {
          const isLast = i === items.length - 1
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1 min-h-[44px]">
              {i > 0 && <ChevronRight className="w-3.5 h-3.5 shrink-0 text-gray-600" />}
              {item.to && !isLast ? (
                <Link to={item.to} className="text-primary-400 hover:text-primary-300 underline">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-gray-200' : undefined}>{item.label}</span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
